var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGcvLineIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.35,
    height: 17.204,
    viewBox: "0 0 24.35 17.204",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GCV",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_175879",
    "data-name": "Group 175879",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_156",
    "data-name": "Ellipse 156",
    cx: 2.821,
    cy: 2.821,
    rx: 2.821,
    ry: 2.821,
    transform: "translate(1.977 10.561)",
    fill: "none",
    stroke: "#f26522",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_157",
    "data-name": "Ellipse 157",
    cx: 1.262,
    cy: 1.262,
    rx: 1.262,
    ry: 1.262,
    transform: "translate(3.537 12.121)",
    fill: "none",
    stroke: "#f26522",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_158",
    "data-name": "Ellipse 158",
    cx: 2.821,
    cy: 2.821,
    rx: 2.821,
    ry: 2.821,
    transform: "translate(15.711 10.561)",
    fill: "none",
    stroke: "#f26522",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_159",
    "data-name": "Ellipse 159",
    cx: 1.262,
    cy: 1.262,
    rx: 1.262,
    ry: 1.262,
    transform: "translate(17.271 12.121)",
    fill: "none",
    stroke: "#f26522",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1294",
    "data-name": "Line 1294",
    x2: 8.389,
    transform: "translate(7.469 14.292)",
    fill: "none",
    stroke: "#f26522",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173285",
    "data-name": "Path 173285",
    d: "M56.828,24.1H58.1a.873.873,0,0,0,.872-.872V17.691a1,1,0,0,0-1-1h-5.21a1.076,1.076,0,0,1-1.076-1.076v-.48a1.076,1.076,0,0,1,1.076-1.076h3.361",
    transform: "translate(-35.624 -9.804)",
    fill: "none",
    stroke: "#f26522",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173286",
    "data-name": "Path 173286",
    d: "M14.485,14.792V1.859A1.359,1.359,0,0,0,13.126.5H1.966A1.465,1.465,0,0,0,.5,1.966V14.792H2.628",
    transform: "translate(-0.5 -0.5)",
    fill: "none",
    stroke: "#f26522",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173287",
    "data-name": "Path 173287",
    d: "M51.547,12.806V9.759A1.359,1.359,0,0,0,50.188,8.4H45.06",
    transform: "translate(-31.075 -5.921)",
    fill: "none",
    stroke: "#f26522",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1295",
    "data-name": "Line 1295",
    x2: 13.985,
    transform: "translate(0 7.316)",
    fill: "none",
    stroke: "#f26522",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1296",
    "data-name": "Line 1296",
    x1: 6.537,
    transform: "translate(7.447 12.4)",
    fill: "none",
    stroke: "#f26522",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1297",
    "data-name": "Line 1297",
    x1: 2.153,
    transform: "translate(0 12.4)",
    fill: "none",
    stroke: "#f26522",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1298",
    "data-name": "Line 1298",
    y1: 7.316,
    transform: "translate(2.25)",
    fill: "none",
    stroke: "#f26522",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1299",
    "data-name": "Line 1299",
    y1: 7.316,
    transform: "translate(5.903)",
    fill: "none",
    stroke: "#f26522",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1300",
    "data-name": "Line 1300",
    y1: 7.316,
    transform: "translate(8.103)",
    fill: "none",
    stroke: "#f26522",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1301",
    "data-name": "Line 1301",
    y1: 7.316,
    transform: "translate(11.791)",
    fill: "none",
    stroke: "#f26522",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173288",
    "data-name": "Path 173288",
    d: "M70.536,27.38H69.6a1.061,1.061,0,0,0-1.061,1.061h0A1.061,1.061,0,0,0,69.6,29.5h.935",
    transform: "translate(-47.186 -18.944)",
    fill: "none",
    stroke: "#f26522",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1302",
    "data-name": "Line 1302",
    x2: 1.444,
    transform: "translate(15.541 8.872)",
    fill: "none",
    stroke: "#f26522",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcvLineIcon);
export default __webpack_public_path__ + "static/media/GCV-LineIcon.d2a1b1bb8c6da4f2dc4faf4adb0aeede.svg";
export { ForwardRef as ReactComponent };